import {ApolloClientInstance} from "../src/apolloClient";

import {ApolloQueryService} from "./ApolloQueryService";

let queryService: ApolloQueryService | null = null;

// ─── Async factory ─────────────────────────────────────────────────────────────
//
// Useful when consumers (e.g. a saga's setup step, or app bootstrap code)
// expect a Promise — keeps call sites uniform even though construction here
// is synchronous.

export function getApolloQueryService(): Promise<ApolloQueryService | null> {
    try {
        const client = ApolloClientInstance.getClient();
        if (!client) return Promise.resolve(null);
        if (queryService) return Promise.resolve(queryService);

        queryService = new ApolloQueryService(client);
        return Promise.resolve(queryService);
    } catch {
        return Promise.resolve(null);
    }
}
